import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ProductCardStatic from 'components/consumer/ProductCardStatic';
import ProductCardGridUI from 'components/consumer/ProductCardGridUI';
import ProductCardStaticPlaceholder from 'components/consumer/ProductCardStaticPlaceholder';
import CardSlider from 'components/consumer/CardSlider';
import isStorybook from 'commons/isStorybook';
import useScreen from 'hooks/useScreen';
const LivestreamFeaturedProducts = t0 => {
  const $ = _c(16);
  const {
    isAdmin: t1,
    products: t2
  } = t0;
  const isAdmin = t1 === undefined ? false : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const products = t3;
  const {
    isMobileOrTablet
  } = useScreen();
  let t4;
  if ($[2] !== isAdmin) {
    t4 = isAdmin || isStorybook();
    $[2] = isAdmin;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const isAdminOrStorybook = t4;
  let t5;
  if ($[4] !== isAdminOrStorybook || $[5] !== products) {
    t5 = products?.map((product, index) => {
      if (isAdminOrStorybook) {
        return <ProductCardStaticPlaceholder />;
      }
      if (!product?.variantsToShow?.[0]?.sku) {
        return null;
      }
      return <ProductCardStatic key={`${product?.id}-${product?.variantsToShow}`} layout="mini" name={product?.name} variantsToShow={product?.variantsToShow} secondaryImage={product?.secondaryImage} productLabel={product?.productLabel} position={index + 1} />;
    });
    $[4] = isAdminOrStorybook;
    $[5] = products;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const productList = t5;
  let t6;
  if ($[7] !== isAdminOrStorybook || $[8] !== productList?.length) {
    t6 = (isAdminOrStorybook || productList?.length > 0) && <div className="text-lg font-bold text-gray-dark mt-6 pb-4 pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:bg-white lg:mt-0 lg:sticky lg:pb-2 lg:pl-0 lg:pr-0 lg:top-0 lg:z-[1]">Featured products</div>;
    $[7] = isAdminOrStorybook;
    $[8] = productList?.length;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isMobileOrTablet || $[11] !== productList) {
    t7 = <div>{isMobileOrTablet ? <div className="LivestreamFeaturedProducts__products__mobile"><CardSlider size="mini">{productList}</CardSlider></div> : <div className="pr-12 w-[233px]"><ProductCardGridUI columnsOnDesktop="1" columnsOnMobile="1" limitWidth={false}>{productList}</ProductCardGridUI></div>}</div>;
    $[10] = isMobileOrTablet;
    $[11] = productList;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <div className="lg:max-h-[calc((93.334vw_-_3rem_-_233px)_/16*9)] lg:overflow-auto min-[1500px]:max-h-[calc((1167px_-_3rem)_/16*9)]">{t6}{t7}</div>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
LivestreamFeaturedProducts.propTypes = {
  products: PropTypes.array,
  isAdmin: PropTypes.bool
};
export default LivestreamFeaturedProducts;